import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { css, styled } from 'styled-components';
import { RibbonVariant } from '../types.js';
const Wrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 28px;
  height: 28px;
  overflow: hidden;
`;
const Ribbon = styled.div `
  font-weight: 700;
  font-size: 8px;
  line-height: 10px;
  transform: rotate(315deg) translateX(-25%) translateY(0);
  transform-origin: center;
  display: flex;
  justify-content: center;
  width: 44px;
  text-transform: uppercase;
  ${({ $variant }) => $variant === RibbonVariant.NEW &&
    css `
      background-color: ${({ theme }) => theme.colors.positive10};
      color: ${({ theme }) => theme.colors.positive120};
    `}
  ${({ $variant }) => $variant === RibbonVariant.BETA &&
    css `
      background-color: ${({ theme }) => theme.colors.link10};
      color: ${({ theme }) => theme.colors.link120};
    `}
  ${({ $variant }) => $variant === RibbonVariant.LEGACY &&
    css `
      background-color: ${({ theme }) => theme.colors.warning10};
      color: ${({ theme }) => theme.colors.warning120};
    `}
`;
export const CornerBadge = memo(function CornerBadge({ variant }) {
    return (_jsx(Wrapper, { children: _jsx(Ribbon, { $variant: variant, children: variant }) }));
});
